import React, { useState, useRef, useEffect, useCallback } from "react";
import "./Covers.css";

import o1 from "../assets/covers/Ousi/i1.jpg";
import o2 from "../assets/covers/Ousi/i2.mp4";
import o3 from "../assets/covers/Ousi/i3.jpg";
import o4 from "../assets/covers/Ousi/i4.jpg";
import o5 from "../assets/covers/Ousi/i5.jpg";

import la1 from "../assets/laguna/1.jpg";
import la2 from "../assets/laguna/2.mp4";
import la3 from "../assets/laguna/3.mp4";
import la4 from "../assets/laguna/4.jpg";
import la5 from "../assets/laguna/5.jpg";

import ea1 from "../assets/easy/1.jpg";
import ea2 from "../assets/easy/2.jpg";
import ea3 from "../assets/easy/3.jpg";
import ea4 from "../assets/easy/4.jpg";
import ea5 from "../assets/easy/5.mp4";

import co5 from "../assets/corrido/1.mp4";
import co2 from "../assets/corrido/2.mp4";
import co3 from "../assets/corrido/3.jpg";
import co4 from "../assets/corrido/4.jpg";
import co1 from "../assets/corrido/5.jpg";

import r1 from "../assets/covers/r1.jpg";
import r2 from "../assets/covers/r2.jpg";

import ma1 from "../assets/oou/w1.jpg";
import ma2 from "../assets/oou/w2.mp4";
import ma3 from "../assets/oou/w3.mp4";
import ma4 from "../assets/oou/w4.jpg";
import ma5 from "../assets/oou/w5.mp4";
import ma6 from "../assets/oou/w6.mp4";
import ma7 from "../assets/oou/w7.jpg";
import ma8 from "../assets/oou/w8.jpg";

import m1 from "../assets/megus/m1.jpg";
import m2 from "../assets/megus/m2.mp4";
import m3 from "../assets/megus/m3.mp4";
import m4 from "../assets/megus/m4.jpg";
import m5 from "../assets/megus/m5.jpg";
import m6 from "../assets/megus/m6.jpg";
import m7 from "../assets/megus/m7.jpg";

import i1 from "../assets/covers/invicto/1.jpg";
import i2 from "../assets/covers/invicto/2.mp4";
import i3 from "../assets/covers/invicto/3.jpg";
import i4 from "../assets/covers/invicto/4.jpg";
import i5 from "../assets/covers/invicto/5.jpg";

import n1 from "../assets/covers/neutro/1.jpg";
import n2 from "../assets/covers/neutro/2.mp4";
import n3 from "../assets/covers/neutro/3.jpg";
import n4 from "../assets/covers/neutro/4.jpg";

import f1 from "../assets/covers/farru/1.jpg";
import f2 from "../assets/covers/farru/2.mp4";
import f3 from "../assets/covers/farru/3.jpg";
import f4 from "../assets/covers/farru/4.jpg";

import ll1 from "../assets/covers/llorona/1.jpg";
import ll2 from "../assets/covers/llorona/2.mp4";
import ll3 from "../assets/covers/llorona/3.jpg";
import ll4 from "../assets/covers/llorona/4.jpg";
import ll5 from "../assets/covers/llorona/5.mp4";

import l1 from "../assets/covers/love/1.jpg";
import l2 from "../assets/covers/love/2.mp4";
import l3 from "../assets/covers/love/3.jpg";
import l4 from "../assets/covers/love/4.mp4";

import s1 from "../assets/covers/storm/1.jpg";
import s2 from "../assets/covers/storm/2.mp4";
import s3 from "../assets/covers/storm/3.jpg";
import s4 from "../assets/covers/storm/4.jpg";
import s5 from "../assets/covers/storm/5.jpg";
import s6 from "../assets/covers/storm/6.jpg";

import va1 from "../assets/covers/variedad/1.jpg";
import va2 from "../assets/covers/variedad/2.jpg";
import va3 from "../assets/covers/variedad/3.jpg";
import va4 from "../assets/covers/variedad/4.jpg";
import va5 from "../assets/covers/variedad/5.jpg";
import va6 from "../assets/covers/variedad/6.jpg";
import va7 from "../assets/covers/variedad/7.jpg";
import va8 from "../assets/covers/variedad/8.jpg";
import va9 from "../assets/covers/variedad/9.jpg";
import va10 from "../assets/covers/variedad/10.jpg";
import va11 from "../assets/covers/variedad/11.jpg";
import va12 from "../assets/covers/variedad/12.jpg";
import va13 from "../assets/covers/variedad/13.jpg";

import b1 from "../assets/Blue/bli.jpg";
import b2 from "../assets/Blue/blueC.mp4";
import b3 from "../assets/Blue/blue.jpg";

import aa from "../assets/covers/sha/1/1.jpg";
import ab from "../assets/covers/sha/1/2.mp4";

import ba from "../assets/covers/sha/2/1.jpg";
import bb from "../assets/covers/sha/2/2.mp4";

import ca from "../assets/covers/sha/3/1.jpg";
import cb from "../assets/covers/sha/3/2.mp4";

import da from "../assets/covers/sha/4/1.jpg";
import db from "../assets/covers/sha/4/2.mp4";

import ea from "../assets/covers/sha/5/1.jpg";
import eb from "../assets/covers/sha/5/2.mp4";

import fa from "../assets/covers/sha/6/1.jpg";
import fb from "../assets/covers/sha/6/2.mp4";

import ga from "../assets/covers/sha/7/1.jpg";
import gb from "../assets/covers/sha/7/2.mp4";

import boa from "../assets/covers/sha/boat/1.jpg";
import bob from "../assets/covers/sha/boat/2.mp4";
import boc from "../assets/covers/sha/boat/3.jpg";
import bod from "../assets/covers/sha/boat/4.jpg";

import ca1 from "../assets/covers/sha/cada/1.jpg";
import ca2 from "../assets/covers/sha/cada/2.mp4";
import ca3 from "../assets/covers/sha/cada/3.jpg";
import ca4 from "../assets/covers/sha/cada/4.jpg";
import ca5 from "../assets/covers/sha/cada/5.jpg";

import cad1 from "../assets/covers/sha/cada/1.jpg";
import cad2 from "../assets/covers/sha/cada/2.mp4";
import cad3 from "../assets/covers/sha/cada/3.jpg";
import cad4 from "../assets/covers/sha/cada/4.jpg";
import cad5 from "../assets/covers/sha/cada/5.jpg";

import membre1 from "../assets/covers/sha/membre/1.jpg";
import membre2 from "../assets/covers/sha/membre/2.mp4";
import membre3 from "../assets/covers/sha/membre/3.jpg";
import membre4 from "../assets/covers/sha/membre/4.mp4";

import moon1 from "../assets/covers/sha/moon/1.jpg";
import moon2 from "../assets/covers/sha/moon/2.mp4";
import moon3 from "../assets/covers/sha/moon/3.jpg";
import moon4 from "../assets/covers/sha/moon/4.jpg";

import no1 from "../assets/covers/sha/no/1.jpg";
import no2 from "../assets/covers/sha/no/2.mp4";
import no3 from "../assets/covers/sha/no/3.mp4";
import no4 from "../assets/covers/sha/no/4.jpg";
import no5 from "../assets/covers/sha/no/5.jpg";

import uk1 from "../assets/covers/sha/uknow/1.jpg";
import uk2 from "../assets/covers/sha/uknow/2.mp4";
import uk3 from "../assets/covers/sha/uknow/3.mp4";
import uk4 from "../assets/covers/sha/uknow/4.jpg";
import uk5 from "../assets/covers/sha/uknow/5.jpg";

import v1 from "../assets/covers/sha/vibe/1.jpg";
import v2 from "../assets/covers/sha/vibe/2.mp4";
import v3 from "../assets/covers/sha/vibe/3.jpg";
import v4 from "../assets/covers/sha/vibe/4.jpg";
import v5 from "../assets/covers/sha/vibe/5.jpg";
import v6 from "../assets/covers/sha/vibe/6.jpg";

import loya1 from "../assets/covers/sha/loyal/1.jpg";
import loya2 from "../assets/covers/sha/loyal/2.jpg";
import loya3 from "../assets/covers/sha/loyal/3.jpg";
import loya4 from "../assets/covers/sha/loyal/4.jpg";
import loya5 from "../assets/covers/sha/loyal/5.mp4";

import coversBg from "../assets/fon3.mp4";

// ─── DATA ────────────────────────────────────────────────────────────────────
const coversItems = [
  [
    { type: "image", src: o1 },
    { type: "video", src: o2 },
    { type: "image", src: o3 },
    { type: "image", src: o4 },
    { type: "image", src: o5 },
  ],
  [
    { type: "image", src: loya1 },
    { type: "image", src: loya2 },
    { type: "image", src: loya3 },
    { type: "image", src: loya4 },
    { type: "video", src: loya5 },
  ],
  [
    { type: "image", src: m1 },
    { type: "video", src: m2 },
    { type: "video", src: m3 },
    { type: "image", src: m4 },
    { type: "image", src: m5 },
    { type: "image", src: m6 },
    { type: "image", src: m7 },
  ],
  [
    { type: "image", src: i1 },
    { type: "video", src: i2 },
    { type: "image", src: i3 },
    { type: "image", src: i4 },
    { type: "image", src: i5 },
  ],
  [
    { type: "image", src: n1 },
    { type: "video", src: n2 },
    { type: "image", src: n3 },
    { type: "image", src: n4 },
  ],
  [{ type: "image", src: r1 }],
  [{ type: "image", src: r2 }],
  [
    { type: "image", src: f1 },
    { type: "video", src: f2 },
    { type: "image", src: f3 },
    { type: "image", src: f4 },
  ],
  [
    { type: "image", src: ma1 },
    { type: "video", src: ma2 },
    { type: "video", src: ma3 },
    { type: "image", src: ma4 },
    { type: "video", src: ma5 },
    { type: "video", src: ma6 },
    { type: "image", src: ma7 },
    { type: "image", src: ma8 },
  ],
  [
    { type: "image", src: ll1 },
    { type: "video", src: ll2 },
    { type: "image", src: ll3 },
    { type: "image", src: ll4 },
    { type: "video", src: ll5 },
  ],
  [
    { type: "image", src: l1 },
    { type: "video", src: l2 },
    { type: "image", src: l3 },
    { type: "video", src: l4 },
  ],
  [
    { type: "image", src: s1 },
    { type: "video", src: s2 },
    { type: "image", src: s3 },
    { type: "image", src: s4 },
    { type: "image", src: s5 },
    { type: "image", src: s6 },
  ],
  [
    { type: "image", src: b1 },
    { type: "video", src: b2 },
    { type: "image", src: b3 },
  ],
  [
    { type: "image", src: co1 },
    { type: "video", src: co2 },
    { type: "image", src: co3 },
    { type: "image", src: co4 },
    { type: "image", src: co5 },
  ],
  [
    { type: "image", src: ea1 },
    { type: "video", src: ea2 },
    { type: "image", src: ea3 },
    { type: "image", src: ea4 },
    { type: "image", src: ea5 },
  ],
  [
    { type: "image", src: la1 },
    { type: "video", src: la2 },
    { type: "image", src: la3 },
    { type: "image", src: la4 },
    { type: "image", src: la5 },
  ],
  [
    { type: "image", src: v1 },
    { type: "video", src: v2 },
    { type: "image", src: v3 },
    { type: "image", src: v4 },
    { type: "image", src: v5 },
    { type: "image", src: v6 },
  ],
  [
    { type: "image", src: uk1 },
    { type: "video", src: uk2 },
    { type: "image", src: uk3 },
    { type: "image", src: uk4 },
    { type: "image", src: uk5 },
  ],

  [
    { type: "image", src: ca1 },
    { type: "video", src: ca2 },
    { type: "image", src: ca3 },
    { type: "image", src: ca4 },
    { type: "image", src: ca5 },
  ],
  [
    { type: "image", src: boa },
    { type: "video", src: bob },
    { type: "image", src: boc },
    { type: "image", src: bod },
    { type: "image", src: boa },
  ],
  [
    { type: "image", src: aa },
    { type: "video", src: ab },
  ],
  [
    { type: "image", src: ba },
    { type: "video", src: bb },
  ],
  [
    { type: "image", src: ca },
    { type: "video", src: cb },
  ],
  [
    { type: "image", src: da },
    { type: "video", src: db },
  ],
  [
    { type: "image", src: ea },
    { type: "video", src: eb },
  ],
  [
    { type: "image", src: fa },
    { type: "video", src: fb },
  ],
  [
    { type: "image", src: ga },
    { type: "video", src: gb },
  ],
  [
    { type: "image", src: cad1 },
    { type: "video", src: cad2 },
    { type: "image", src: cad3 },
    { type: "image", src: cad4 },
    { type: "image", src: cad5 },
  ],
  [
    { type: "image", src: membre1 },
    { type: "video", src: membre2 },
    { type: "image", src: membre3 },
    { type: "video", src: membre4 },
  ],
  [
    { type: "image", src: moon1 },
    { type: "video", src: moon2 },
    { type: "image", src: moon3 },
    { type: "video", src: moon4 },
  ],
  [
    { type: "image", src: no1 },
    { type: "video", src: no2 },
    { type: "video", src: no3 },
    { type: "video", src: no4 },
    { type: "video", src: no5 },
  ],

  [{ type: "image", src: va1 }],
  [{ type: "image", src: va2 }],
  [{ type: "image", src: va3 }],
  [{ type: "image", src: va4 }],
  [{ type: "image", src: va5 }],
  [{ type: "image", src: va6 }],
  [{ type: "image", src: va7 }],
  [{ type: "image", src: va8 }],
  [{ type: "image", src: va9 }],
  [{ type: "image", src: va10 }],
  [{ type: "image", src: va11 }],
  [{ type: "image", src: va12 }],
  [{ type: "image", src: va13 }],
];

export default function Covers() {
  // ── Grid drag state ───────────────────────────────────────────────────────
  const viewportRef = useRef(null);
  const planeRef = useRef(null);
  const bgVideoRef = useRef(null);

  const pos = useRef({ x: 0, y: 0 });
  const vel = useRef({ x: 0, y: 0 });
  const raf = useRef(null);
  const drag = useRef({
    active: false,
    startX: 0,
    startY: 0,
    lastX: 0,
    lastY: 0,
    moved: false,
  });
  const tilt = useRef({ rx: 0, ry: 0 });

  // ── Modal state ───────────────────────────────────────────────────────────
  const [openModalIndex, setOpenModalIndex] = useState(null);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);

  // ── Hint state ────────────────────────────────────────────────────────────
  const [showHint, setShowHint] = useState(true);

  // ─── Animation ───────────────────────────────────────────────────────────
  const applyTransform = useCallback(() => {
    const plane = planeRef.current;
    if (!plane) return;
    tilt.current.rx *= 0.88;
    tilt.current.ry *= 0.88;
    plane.style.transform = `
      translate3d(${pos.current.x}px, ${pos.current.y}px, 0)
      rotateX(${tilt.current.rx}deg)
      rotateY(${tilt.current.ry}deg)
    `;
  }, []);

  const inertiaLoop = useCallback(() => {
    vel.current.x *= 0.91;
    vel.current.y *= 0.91;
    pos.current.x += vel.current.x;
    pos.current.y += vel.current.y;
    applyTransform();
    if (Math.abs(vel.current.x) > 0.1 || Math.abs(vel.current.y) > 0.1) {
      raf.current = requestAnimationFrame(inertiaLoop);
    } else {
      raf.current = null;
    }
  }, [applyTransform]);

  // ─── Mouse drag ───────────────────────────────────────────────────────────
  useEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;

    const onMouseDown = (e) => {
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = null;
      }
      drag.current = {
        active: true,
        startX: e.clientX,
        startY: e.clientY,
        lastX: e.clientX,
        lastY: e.clientY,
        moved: false,
      };
      viewport.style.cursor = "grabbing";
    };

    const onMouseMove = (e) => {
      if (!drag.current.active) return;
      const dx = e.clientX - drag.current.lastX;
      const dy = e.clientY - drag.current.lastY;
      if (
        Math.abs(e.clientX - drag.current.startX) > 4 ||
        Math.abs(e.clientY - drag.current.startY) > 4
      )
        drag.current.moved = true;

      pos.current.x += dx;
      pos.current.y += dy;
      tilt.current.ry = Math.max(-14, Math.min(14, dx * 0.6));
      tilt.current.rx = Math.max(-14, Math.min(14, -dy * 0.6));
      vel.current.x = dx;
      vel.current.y = dy;
      drag.current.lastX = e.clientX;
      drag.current.lastY = e.clientY;
      applyTransform();
      if (showHint) setShowHint(false);
    };

    const onMouseUp = () => {
      drag.current.active = false;
      viewport.style.cursor = "grab";
      if (Math.abs(vel.current.x) > 0.5 || Math.abs(vel.current.y) > 0.5)
        raf.current = requestAnimationFrame(inertiaLoop);
    };

    viewport.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      viewport.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [applyTransform, inertiaLoop, showHint]);

  // ─── Touch drag ───────────────────────────────────────────────────────────
  useEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;

    const onTouchStart = (e) => {
      if (e.touches.length !== 1) return;
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = null;
      }
      const t = e.touches[0];
      drag.current = {
        active: true,
        startX: t.clientX,
        startY: t.clientY,
        lastX: t.clientX,
        lastY: t.clientY,
        moved: false,
      };
    };

    const onTouchMove = (e) => {
      if (!drag.current.active || e.touches.length !== 1) return;
      const t = e.touches[0];
      const dx = t.clientX - drag.current.lastX;
      const dy = t.clientY - drag.current.lastY;
      const totalDx = Math.abs(t.clientX - drag.current.startX);
      const totalDy = Math.abs(t.clientY - drag.current.startY);
      if (totalDx > 5 || totalDy > 5) {
        drag.current.moved = true;
        if (totalDx > totalDy) e.preventDefault();
      }
      pos.current.x += dx;
      pos.current.y += dy;
      tilt.current.ry = Math.max(-14, Math.min(14, dx * 0.6));
      tilt.current.rx = Math.max(-14, Math.min(14, -dy * 0.6));
      vel.current.x = dx;
      vel.current.y = dy;
      drag.current.lastX = t.clientX;
      drag.current.lastY = t.clientY;
      applyTransform();
      if (showHint) setShowHint(false);
    };

    const onTouchEnd = () => {
      drag.current.active = false;
      if (Math.abs(vel.current.x) > 0.5 || Math.abs(vel.current.y) > 0.5)
        raf.current = requestAnimationFrame(inertiaLoop);
    };

    viewport.addEventListener("touchstart", onTouchStart, { passive: true });
    viewport.addEventListener("touchmove", onTouchMove, { passive: false });
    viewport.addEventListener("touchend", onTouchEnd);
    return () => {
      viewport.removeEventListener("touchstart", onTouchStart);
      viewport.removeEventListener("touchmove", onTouchMove);
      viewport.removeEventListener("touchend", onTouchEnd);
    };
  }, [applyTransform, inertiaLoop, showHint]);

  // ─── Background video ─────────────────────────────────────────────────────
  useEffect(() => {
    const videoEl = bgVideoRef.current;
    if (!videoEl) return;
    const tryPlay = () => {
      const p = videoEl.play();
      if (p !== undefined) p.catch(() => {});
    };
    tryPlay();
    const resume = () => videoEl.play().catch(() => {});
    document.addEventListener("click", resume, { once: true });
    document.addEventListener("touchstart", resume, { once: true });
    return () => {
      document.removeEventListener("click", resume);
      document.removeEventListener("touchstart", resume);
    };
  }, []);

  // ─── Cleanup RAF ──────────────────────────────────────────────────────────
  useEffect(() => {
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);

  // ─── Modal ────────────────────────────────────────────────────────────────
  const openModal = (index) => {
    setOpenModalIndex(index);
    setCurrentMediaIndex(0);
  };
  const closeModal = () => setOpenModalIndex(null);
  const nextMedia = () => {
    if (openModalIndex !== null) {
      const media = coversItems[openModalIndex];
      setCurrentMediaIndex((p) => (p + 1) % media.length);
    }
  };
  const prevMedia = () => {
    if (openModalIndex !== null) {
      const media = coversItems[openModalIndex];
      setCurrentMediaIndex((p) => (p - 1 + media.length) % media.length);
    }
  };

  const handleCardClick = (e, index) => {
    if (drag.current.moved) return;
    openModal(index);
  };

  // ─── RENDER ───────────────────────────────────────────────────────────────
  return (
    <section id="covers" className="covers">
      <video
        ref={bgVideoRef}
        className="covers-bg-video"
        src={coversBg}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />

      <h2 className="covers-main-title">Covers</h2>

      {/* Drag hint */}
      <div className={`drag-hint ${showHint ? "visible" : "hidden"}`}>
        <span className="drag-hint-icon">✦</span>
        Arrastra para explorar
      </div>

      {/* Perspective viewport */}
      <div className="covers-viewport" ref={viewportRef}>
        {/* Draggable plane */}
        <div className="grid-plane" ref={planeRef}>
          {coversItems.map((media, i) => {
            const hasVideo = media.some((m) => m.type === "video");
            return (
              <div
                key={i}
                className="grid-card"
                onClick={(e) => handleCardClick(e, i)}
                onMouseEnter={(e) => {
                  if (!drag.current.active)
                    e.currentTarget.classList.add("hovered");
                }}
                onMouseLeave={(e) =>
                  e.currentTarget.classList.remove("hovered")
                }
              >
                <img src={media[0].src} alt={`Cover ${i + 1}`} loading="lazy" />
                <div className="grid-card-overlay">
                  {hasVideo && <span className="has-video-badge">▶ Video</span>}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Modal */}
      {openModalIndex !== null && (
        <div className="covers-modal-overlay" onClick={closeModal}>
          <div
            className="covers-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="covers-modal-close" onClick={closeModal}>
              ×
            </button>
            <button className="covers-modal-prev" onClick={prevMedia}>
              ‹
            </button>
            <button className="covers-modal-next" onClick={nextMedia}>
              ›
            </button>
            {coversItems[openModalIndex][currentMediaIndex].type === "image" ? (
              <img
                src={coversItems[openModalIndex][currentMediaIndex].src}
                alt="media"
              />
            ) : (
              <video
                src={coversItems[openModalIndex][currentMediaIndex].src}
                controls
                autoPlay
                muted
                playsInline
                className="covers-modal-video"
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
}
